var React = require('react');

function Sort (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Sort"),React.createElement("line",{"x1":"0.5","y1":"8","x2":"2.5","y2":"8","stroke":"black","strokeLinecap":"round","key":1}),React.createElement("line",{"x1":"0.5","y1":"5.5","x2":"4.5","y2":"5.5","stroke":"black","strokeLinecap":"round","key":2}),React.createElement("line",{"x1":"0.5","y1":"3","x2":"6.5","y2":"3","stroke":"black","strokeLinecap":"round","key":3}),React.createElement("path",{"d":"M9 9.82367L9.00004 1","stroke":"black","strokeLinecap":"round","key":4}),React.createElement("path",{"d":"M12 7.26302L9 10.263L6 7.26302","stroke":"black","strokeLinecap":"round","strokeLinejoin":"round","key":5})]);
}

Sort.defaultProps = {"width":"13","height":"11","viewBox":"0 0 13 11","fill":"none"};

module.exports = Sort;

Sort.default = Sort;
